import { AdminRoutingModule } from './admin.routing';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './admin.component';
import { CoursesComponent } from './components/courses/courses.component';
import { SharedModule } from '../shared/shared.module';
import { CourseComponent } from './components/courses/course/course.component';
import { CourseInfoComponent } from './components/courses/course/info/info.component';
import { LessonComponent } from './components/courses/course/lesson/lesson.component';
import { UsersComponent } from './components/users/users.component';
import { UserComponent } from './components/users/user/user.component';
import { EnrollmentsComponent } from './components/enrollments/enrollments.component';
import { MaterialsComponent } from './components/materials/materials.component';
import { DrawingsComponent } from './components/drawings/drawings.component';
import { ReviewsComponent } from './components/reviews/reviews.component';
import { CommentsComponent } from './components/comments/comments.component';
import { SessionComponent } from './components/courses/course/session/session.component';
import { NewEnrollmentComponent } from './components/enrollments/new-enrollment/new-enrollment.component';
import { NewTeacherComponent } from './components/users/new-teacher/new-teacher.component';
import { SuperAdminComponent } from './components/super-admin/super-admin.component';
import { SuperAdminHomepageComponent } from './components/super-admin/super-admin-homepage/super-admin-homepage.component';
import { SuperAdminAdminsComponent } from './components/super-admin/super-admin-admins/super-admin-admins.component';
import { SuperAdminConfigsComponent } from './components/super-admin/super-admin-configs/super-admin-configs.component';
import { SuperAdminGalleryComponent } from './components/super-admin/super-admin-gallery/super-admin-gallery.component';
import { TransactionsComponent } from './components/transactions/transactions.component';
import { NewTransactionComponent } from './components/transactions/new-transaction/new-transaction.component';
import { PaymentsComponent } from './components/payments/payments.component';

@NgModule({
  declarations: [AdminComponent, CoursesComponent, CourseComponent, CourseInfoComponent, LessonComponent, UsersComponent, UserComponent, EnrollmentsComponent, MaterialsComponent, DrawingsComponent, ReviewsComponent, CommentsComponent, SessionComponent, NewEnrollmentComponent, NewTeacherComponent, SuperAdminComponent, SuperAdminHomepageComponent, SuperAdminAdminsComponent, SuperAdminConfigsComponent, SuperAdminGalleryComponent, TransactionsComponent, NewTransactionComponent, PaymentsComponent],
  imports: [
    CommonModule,
    SharedModule,
    AdminRoutingModule
  ]
})
export class AdminModule { }
